"use client";

import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { motion, useReducedMotion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP);
export default function Eurocontrol() {
  const container = useRef<HTMLDivElement>(null);
  const prefersReducedMotion = useReducedMotion();
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".hero-eyebrow", {
        y: 24,
        filter: "blur(8px)"
      });
      gsap.set(".hero-headline-line", {
        y: 40,
        filter: "blur(10px)"
      });
      gsap.set(".hero-ring", {
        rotate: 0,
        transformOrigin: "50% 50%"
      });
      const tl = gsap.timeline({
        defaults: {
          ease: "power3.out"
        }
      });
      tl.to(".hero-eyebrow", {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        duration: 0.72
      }).to(".hero-headline-line", {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        duration: 0.9,
        stagger: 0.09
      }, "-=0.5");
      gsap.to(".hero-ring", {
        rotate: 360,
        duration: 120,
        ease: "none",
        repeat: -1
      });
      gsap.to(".hero-aurora", {
        yPercent: 8,
        ease: "none",
        scrollTrigger: {
          trigger: container.current,
          start: "top top",
          end: "bottom top",
          scrub: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".hero-eyebrow", ".hero-headline-line"], {
        opacity: 1,
        y: 0,
        filter: "blur(0px)"
      });
    });
  }, {
    scope: container
  });
  return;
}